import { Amplitude, Events } from '@iwoca/frontend-tracking-library';
import { Trans } from '@lingui/macro';
import clsx from 'clsx';
import { useLocale } from 'hooks/useLocale';
import { usePathname } from 'hooks/usePathname/usePathname';
import { Link } from 'react-router-dom';
import { getCookie } from 'utils/cookieHelper';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from '../Navigation.module.css';

type TProps = {
  setShowHelpModal: (showHelpModal: boolean) => void;
};

export const SupportItems = ({ setShowHelpModal }: TProps) => {
  const isLoggedIn = getCookie('isLoggedIn') === 'True';
  const pathname = usePathname();
  const { locale } = useLocale();

  const handleHelpTracking = () => {
    Amplitude.track(
      Events.introducerPortal.introducerPortalEventCreator({
        event: AMPLITUDE_EVENTS.modalOpened,
        locale,
        payload: {
          'Page name': document.title,
          URL: window.location.pathname,
          'Modal name': 'Help modal',
        },
      }),
    );
  };

  const handleFAQsClickTracking = () => {
    Amplitude.track(
      Events.introducerPortal.introducerPortalEventCreator({
        event: AMPLITUDE_EVENTS.internalLinkClicked,
        locale,
        payload: {
          'Page name': document.title,
          URL: window.location.pathname,
          'CTA destination': 'FAQs',
          'CTA text': 'FAQs',
          'CTA URL': PATH_NAMES.faqs(),
        },
      }),
    );
  };

  return (
    <>
      {isLoggedIn && (
        <div className={styles.navItem}>
          <Link
            to={PATH_NAMES.faqs()}
            onClick={handleFAQsClickTracking}
            className={clsx(styles.navItemLink, {
              [styles.navItemLinkActive]: pathname === PATH_NAMES.faqs(),
            })}
            data-testid="faqs-link"
          >
            <Trans>FAQs</Trans>
          </Link>
        </div>
      )}
      <div className={styles.navItem}>
        <button
          className={styles.navItemLink}
          onClick={() => {
            handleHelpTracking();
            setShowHelpModal(true);
          }}
        >
          <Trans>Contact us</Trans>
        </button>
      </div>
    </>
  );
};
